/* Quiz Routine : barre mobile épinglée, onglet et pop-up (14/10/2026). Voir snippets/quiz-routine-entries.liquid. */
(function () {
  var DONE = 'coalition_quiz_done';
  var SHOWN = 'coalition_quiz_popup';
  var WEEK = 7 * 24 * 3600 * 1000;
  var MAX_PER_WEEK = 2;
  var ARM_AFTER_MS = 6000;

  function read(store, key) { try { return store.getItem(key); } catch (e) { return null; } }
  function write(store, key, value) { try { store.setItem(key, value); } catch (e) { /* storage blocked */ } }

  // Pinned bar: shows once the bar of the header has scrolled out of view (phone only).
  var bar = document.querySelector('[data-qr-bar]');
  var float = document.querySelector('[data-qr-float]');
  if (bar && float && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var on = !entry.isIntersecting && entry.boundingClientRect.top < 0 && bar.offsetParent !== null;
      float.classList.toggle('is-on', on);
      float.setAttribute('aria-hidden', String(!on));
      float.tabIndex = on ? 0 : -1;
    }).observe(bar);
  }

  var veil = document.querySelector('[data-qr-veil]');
  if (!veil) return;
  var lastFocus = null;

  function open() {
    if (veil.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    veil.classList.add('is-open');
    var close = veil.querySelector('[data-qr-close]');
    if (close) close.focus({ preventScroll: true });
  }
  function close() {
    veil.classList.remove('is-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-qr-open]'), function (button) {
    button.addEventListener('click', open);
  });
  veil.addEventListener('click', function (event) {
    if (event.target === veil || event.target.closest('[data-qr-close]')) close();
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && veil.classList.contains('is-open')) close();
  });

  // Automatic opening: never after a finished quiz, twice a week at most, once per visit.
  if (read(localStorage, DONE)) {
    Array.prototype.forEach.call(document.querySelectorAll('.qr-tab'), function (tab) { tab.remove(); });
    return;
  }
  var now = Date.now();
  var history = [];
  try { history = JSON.parse(read(localStorage, SHOWN) || '[]').filter(function (t) { return now - t < WEEK; }); } catch (e) { history = []; }
  if (history.length >= MAX_PER_WEEK || read(sessionStorage, SHOWN)) return;

  var armed = false;
  setTimeout(function () { armed = true; }, ARM_AFTER_MS);

  // The cookie banner (Avada) comes first: no pop-up on top of it, the chance is kept for later.
  function cookieBannerOpen() {
    // The wrapper has no height: the visible part is its container, fixed to the screen.
    var el = document.getElementById('Avada-CookiesBar');
    if (!el) return false;
    var box = (el.querySelector('.Avada-CookiesBar_Container') || el).getBoundingClientRect();
    return box.width > 0 && box.height > 0;
  }

  function auto() {
    if (!armed || read(sessionStorage, SHOWN) || cookieBannerOpen()) return;
    write(sessionStorage, SHOWN, '1');
    history.push(Date.now());
    write(localStorage, SHOWN, JSON.stringify(history));
    open();
  }

  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    // Computer: the pointer leaves through the top of the window.
    document.addEventListener('mouseout', function (event) {
      if (!event.relatedTarget && event.clientY <= 0) auto();
    });
  } else {
    // Phone: a fast scroll back up after reading a little.
    var lastY = window.scrollY;
    var lastT = performance.now();
    var deepest = lastY;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      var t = performance.now();
      deepest = Math.max(deepest, y);
      var speed = (lastY - y) / Math.max(1, t - lastT);
      if (deepest > 600 && y > 200 && speed > 1.6) auto();
      lastY = y;
      lastT = t;
    }, { passive: true });
  }
})();
